var component = /-?\d+(\.\d+)?%?/g;
function extractComponents(color) {
  return color.match(component);
}

module.exports = extractComponents;


//////////////////
// WEBPACK FOOTER
// ./~/pure-color/parse/extractComponents.js
// module id = 763
// module chunks = 0